import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { VENUE_APPROVAL_MESSAGE, VENUE_PAID_MESSAGE } from '../lib/entitlements';
import PremiumCta from './PremiumCta';

// A6: mekânda kilitli özelliğin yerine gösterilen açıklama (mevcut kart ve düğme stilleri).
// reason='paid'    → ücretsiz mekân (403 VENUE_PAID_REQUIRED): "Premium ol" (ödeme bağlantısı) ücretli üyelik açar.
// reason='approval' → ücretli ama profili onaysız/gizli mekân (403 VENUE_APPROVAL_REQUIRED): profil onayı açar.
export default function PaidFeatureLock({ feature, message, reason = 'paid', variant = 'card', testId }) {
  const approval = reason === 'approval';
  const id = testId || (approval ? 'venue-approval-lock' : 'venue-paid-lock');
  const title = approval ? 'Profil onayından sonra açılır' : 'Ücretli üyelikle açılır';
  const text = message || (approval ? VENUE_APPROVAL_MESSAGE : VENUE_PAID_MESSAGE);
  const actions = <div className="application-buttons">
    {approval ? <Link className="action-primary" to="/venue/profile" data-testid={`${id}-profile`}>Profilimi aç</Link>
      : <><PremiumCta /><Link className="action-secondary" to="/pro" data-testid={`${id}-pro`}>Ücretli mekân üyeliğini incele</Link></>}
    <Link className="action-secondary" to="/venue/applications">Gelen teklifleri aç</Link>
  </div>;
  if (variant === 'chat') return <div className="chat-guided-intro" role="status" data-testid={id} data-lock-reason={reason}>
    <strong><Lock size={15} aria-hidden="true" /> {title}</strong>
    <p>{feature ? `${feature}: ` : ''}{text}{approval ? '' : ' Profilini ve sesli DNA’nı güncellemeye de devam edebilirsin.'}</p>{actions}
  </div>;
  return <section className="demand-card" role="status" data-testid={id} data-lock-reason={reason}>
    <p className="demand-eyebrow"><Lock size={14} aria-hidden="true" /> {title}</p>
    {feature && <h2>{feature}</h2>}
    <p>{text}</p>{actions}
  </section>;
}
